import { createRouter, createWebHistory } from "vue-router";
const routes = [
  {
    path: "/",
    name: "index",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index.vue"),
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/home.vue"),
        meta: { code: 100, title: "首页" },
      },
      {
        path: "tool",
        name: "tool",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/tool/index.vue"),
        meta: { title: "工具" },
      },
      {
        path: "iframe",
        name: "iframe",
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/hr/index.vue"),
      },
      {
        path: "/user_center",
        name: "userCenter",
        component: () =>
          import(
            /* webpackChunkName: "userCenter" */ "../views/userCenter.vue"
          ),
        meta: { title: "个人中心" },
      },
      {
        path: "schedule",
        name: "schedule",
        component: () =>
          import(/* webpackChunkName: "schedule" */ "../views/schedule.vue"),
        meta: { code: 888, title: "日历" },
      },
      {
        path: "work_bench",
        name: "work_bench",
        component: () =>
          import(
            /* webpackChunkName: "schedule" */ "../views/work_bench/index.vue"
          ),
        redirect: "/work_bench/schedule",
        meta: { code: 200 },
        children: [
          {
            path: "contract",
            name: "contract",
            component: () =>
              import(
                /* webpackChunkName: "sample" */ "../views/work_bench/sales_manage/contract.vue"
              ),
            meta: { title: "合同列表" },
          },
          {
            path: "add_contract",
            name: "add_contract",
            component: () =>
              import(
                /* webpackChunkName: "sample" */ "../views/work_bench/sales_manage/contract_add.vue"
              ),
            meta: { title: "合同" },
          },
          {
            path: "contract_detail",
            name: "contract_detail",
            component: () =>
              import(
                /* webpackChunkName: "sample" */ "../views/work_bench/sales_manage/contract_detail.vue"
              ),
            meta: { title: "合同详情" },
          },
          {
            path: "material",
            name: "material",
            component: () =>
              import(
                "../views/work_bench/product_management/material/index.vue"
              ),
            redirect: "/work_bench/material/list",
            children: [
              {
                path: "list",
                name: "materiallist",
                component: () =>
                  import(
                    "../views/work_bench/product_management/material/components/index.vue"
                  ),
                meta: { title: "物料列表" },
              },
            ],
          },
          {
            path: "materialadd",
            name: "materialadd",
            component: () =>
              import(
                "../views/work_bench/product_management/material/components/add.vue"
              ),
            meta: { title: "物料" },
          },
          {
            path: "bom",
            name: "bom",
            component: () =>
              import("../views/work_bench/product_management/bom/index.vue"),
            redirect: "/work_bench/bom/list",
            children: [
              {
                path: "list",
                name: "bomlist",
                component: () =>
                  import(
                    "../views/work_bench/product_management/bom/components/index.vue"
                  ),
                meta: { title: "物料清单列表" },
              },
            ],
          },
          {
            path: "bomadd",
            name: "bomadd",
            component: () =>
              import(
                "../views/work_bench/product_management/bom/components/add.vue"
              ),
            meta: { title: "物料清单" },
          },
          {
            path: "customproduct",
            name: "customproduct",
            component: () =>
              import(
                "../views/work_bench/product_management/customproduct/index.vue"
              ),
            meta: { title: "标准品列表" },
          },
          {
            path: "customproductadd",
            name: "customproductadd",
            component: () =>
              import(
                "../views/work_bench/product_management/customproduct/add.vue"
              ),
            meta: { title: "标准品" },
          },
          {
            path: "productmarket",
            name: "productmarket",
            component: () =>
              import("../views/work_bench/product_management/market/index.vue"),
            meta: { title: "产品资讯" },
          },
          {
            path: "drawingsearch",
            name: "drawingsearch",
            component: () =>
              import("../views/work_bench/search/drawSearch.vue"),
            meta: { title: "图纸查询" },
          },
          {
            path: "bomsearch",
            name: "bomsearch",
            component: () => import("../views/work_bench/search/bom.vue"),
            meta: { title: "BOM清单查询" },
          },
          {
            path: "drawparts",
            name: "drawparts",
            component: () => import("../views/work_bench/search/drawparts.vue"),
            meta: { title: "图纸配件库查询" },
          },
          // 待办
          {
            path: "Link",
            name: "link",
            component: () => import("../views/work_bench/link_todo/list.vue"),
            meta: { title: "待办" },
          },
          {
            path: "demo",
            name: "demo",
            component: () => import("../views/work_bench/demo/list.vue"),
            meta: { code: 4010, title: "样机管理列表" },
          },
          {
            path: "travel_reimbursement_add",
            name: "travel_reimbursement_add",
            component: () => import("../views/reimbursement/add.vue"),
            meta: { code: 2500 },
          },
          {
            path: "travel_reimbursement",
            name: "travel_reimbursement",
            component: () =>
              import(
                /* webpackChunkName: "home" */ "../views/reimbursement/index.vue"
              ),
            meta: { code: 2500 },
          },
          {
            path: "clueAndBusinessStatistics",
            name: "clueAndBusinessStatistics",
            component: () =>
              import(
                "../views/work_bench/statistics/clueAndBusinessStatistics.vue"
              ),
            meta: { title: "线索/商..." },
          },
          {
            path: "weekly",
            name: "weekly",
            component: () =>
              import("../views/work_bench/statistics/weekly/index.vue"),
            meta: { code: 200, title: "周报" },
          },
          {
            path: "schedule",
            name: "scheschedule",
            component: () =>
              import(
                /* webpackChunkName: "schedule" */ "../views/schedule.vue"
              ),
            meta: { code: 200, title: "日程" },
          },
          {
            path: "client",
            name: "client",
            component: () =>
              import(
                /* webpackChunkName: "client" */ "../views/work_bench/client.vue"
              ),
            meta: { code: 200, title: "客户列表" },
          },
          {
            path: "client_detail/:id",
            name: "client_detail",
            component: () =>
              import(
                /* webpackChunkName: "client_detail" */ "../views/work_bench/client_detail.vue"
              ),
            meta: { code: 200, title: "客户详情" },
          },
          {
            path: "client_add",
            name: "client_add",
            component: () =>
              import(
                /* webpackChunkName: "client_add" */ "../views/work_bench/client/client_add.vue"
              ),
            meta: { code: 200, title: "客户申请" },
          },
          {
            path: "client_apply",
            name: "client_apply",
            component: () =>
              import(
                /* webpackChunkName: "client_apply" */ "../views/work_bench/client/client_apply.vue"
              ),
            meta: { code: 200, title: "客户申请列表" },
          },
          {
            path: "capply-detail",
            name: "capply-detail",
            component: () =>
              import("../views/work_bench/client/clientDetial.vue"),
            meta: { code: 200, title: "客户申请详情" },
          },
          {
            path: "client_check",
            name: "client_check",
            component: () =>
              import(
                /* webpackChunkName: "client_apply" */ "../views/work_bench/client/client-check.vue"
              ),
            meta: { code: 200, title: "客户申请审核" },
          },
          {
            path: "contracts",
            name: "contracts",
            component: () =>
              import(
                /* webpackChunkName: "contracts" */ "../views/work_bench/contracts.vue"
              ),
            meta: { code: 200, title: "联系人列表" },
          },
          {
            path: "contracts_detail/:id",
            name: "contracts_detail",
            component: () =>
              import(
                /* webpackChunkName: "contracts_detail" */ "../views/work_bench/contracts_detail.vue"
              ),
            meta: { code: 200, title: "联系人详情" },
          },
          {
            path: "visit",
            name: "visit",
            component: () =>
              import(
                /* webpackChunkName: "visit" */ "../views/work_bench/visit.vue"
              ),
            meta: { code: 200, title: "客户拜访列表" },
          },
          {
            path: "outvisit",
            name: "outvisit",
            component: () =>
              import(
                /* webpackChunkName: "visit" */ "../views/work_bench/outvisit.vue"
              ),
            meta: { code: 200, title: "出差(测试部)" },
          },
          {
            path: "visit_detail/:id",
            name: "visit_detail",
            component: () =>
              import(
                /* webpackChunkName: "visit_detail" */ "../views/work_bench/visit_detail.vue"
              ),
            meta: { code: 200, title: "客户拜访详情" },
          },
          {
            path: "clue",
            name: "clue",
            component: () =>
              import(
                /* webpackChunkName: "clue" */ "../views/work_bench/sales_manage/clue.vue"
              ),
            meta: { code: 200, title: "线索列表" },
          },
          {
            path: "clue_detail/:id",
            name: "clue_detail",
            component: () =>
              import(
                /* webpackChunkName: "clue_detail" */ "../views/work_bench/sales_manage/clue_detail.vue"
              ),
            meta: { code: 200, title: "线索详情" },
          },
          {
            path: "business",
            name: "business",
            component: () =>
              import(
                /* webpackChunkName: "business" */ "../views/work_bench/sales_manage/business.vue"
              ),
            meta: { code: 200, title: "商机列表" },
          },
          {
            path: "business_detail/:id",
            name: "business_detail",
            component: () =>
              import(
                /* webpackChunkName: "business_detail" */ "../views/work_bench/sales_manage/business_detail.vue"
              ),
            meta: { code: 200, title: "商机详情" },
          },
          {
            path: "sample",
            name: "sample",
            component: () =>
              import(
                /* webpackChunkName: "sample" */ "../views/work_bench/sales_manage/sample.vue"
              ),
            meta: { code: 200, keepAlive: true, title: "样品列表" },
          },
          {
            path: "sample_detail/:id?",
            name: "sample_detail",
            component: () =>
              import(
                /* webpackChunkName: "sample_detail" */ "../views/work_bench/sales_manage/sample_detail.vue"
              ),
            meta: { code: 200, title: "样品详情" },
          },
          {
            path: "quotation",
            name: "quotation",
            component: () =>
              import(
                /* webpackChunkName: "sample" */ "../views/work_bench/sales_manage/quotation.vue"
              ),
            meta: { code: 200, title: "报价列表" },
          },
          {
            path: "quotation_detail/:id?",
            name: "quotation_detail",
            component: () =>
              import("../views/work_bench/sales_manage/quotation_detail.vue"),
            meta: { code: 200, title: "报价详情" },
          },
          {
            path: "quotation_add/:id?",
            name: "quotation_add",
            component: () =>
              import("../views/work_bench/sales_manage/quotation_add.vue"),
            meta: { code: 200, title: "报价" },
          },
          {
            path: "statistic_analysis",
            name: "statistic_analysis",
            component: () =>
              import(
                "../views/work_bench/analytical_manage/statistic_analysis/index.vue"
              ),
            meta: { code: 200, title: "统计分析" },
          },
          {
            path: "data_board",
            name: "data_board",
            component: () =>
              import("../views/work_bench/analytical_manage/data_board.vue"),
            meta: { code: 200, title: "数据看板" },
          },
          {
            path: "customerDoard",
            name: "customerDoard",
            component: () =>
              import("../views/work_bench/analytical_manage/customerDoard.vue"),
            meta: { code: 200, title: "客户数据看板" },
          },
          {
            path: "salesDashboard",
            name: "salesDashboard",
            component: () =>
              import(
                "../views/work_bench/analytical_manage/salesDashboard.vue"
              ),
            meta: { code: 200, title: "销售数据看板" },
          },
          {
            path: "product_analysis",
            name: "productAnalysis",
            component: () =>
              import(
                "../views/work_bench/analytical_manage/productAnalysis.vue"
              ),
            meta: { code: 200, title: "产品统计" },
          },
          {
            path: "pms_analysis",
            name: "pmsAnalysis",
            component: () =>
              import("../views/work_bench/statistics/pms/pmsStatistics.vue"),
            meta: { code: 200, title: "项目管理" },
          },
          {
            path: "price_rule",
            name: "price_rule",
            component: () =>
              import(
                "../views/work_bench/product_management/price_rule/index.vue"
              ),
            meta: { title: "定价策略规则" },
          },
          {
            path: "price_rule_add",
            name: "price_rule_add",
            component: () =>
              import(
                "../views/work_bench/product_management/price_rule/add.vue"
              ),
            meta: { title: "定价策略规则" },
          },
          {
            path: "kpgl",
            name: "kpgl",
            component: () => import("../views/work_bench/ehr/kpgl.vue"),
            meta: { title: "考评管理" },
          },
          {
            path: "my_kp",
            name: "my_kp",
            component: () => import("../views/work_bench/ehr/my_kp.vue"),
            meta: { title: "我的考评" },
          },
          {
            path: "quarter",
            name: "quarter",
            component: () =>
              import("../views/work_bench/ehr/quarter/quarter_gl.vue"),
            meta: { title: "季度会议" },
          },
          {
            path: "talks_record",
            name: "talks_record",
            component: () =>
              import("../views/work_bench/talksRecord/index.vue"),
            meta: { code: 200, title: "洽谈记录" },
          },
          {
            path: "reimbursement",
            name: "reimbursement",
            component: () =>
              import("../views/work_bench/reimbursement/index.vue"),
            meta: { code: 200, title: "报销列表" },
          },
          {
            path: "reimbursement_edit",
            name: "reimbursement_edit",
            component: () =>
              import("../views/work_bench/reimbursement/edit.vue"),
            meta: { code: 200, title: "报销申请" },
          },
          {
            path: "reimbursement_detail",
            name: "reimbursement_detail",
            component: () =>
              import("../views/work_bench/reimbursement/detail.vue"),
            meta: { code: 200, title: "报销详情" },
          },
          {
            path: "entertainment",
            name: "entertainment",
            component: () =>
              import("../views/work_bench/entertainment/index.vue"),
            meta: { code: 200, title: "超标申请列表" },
          },
          {
            path: "entertainment_edit",
            name: "entertainment_edit",
            component: () =>
              import("../views/work_bench/entertainment/edit.vue"),
            meta: { code: 200, title: "超标申请" },
          },
          {
            path: "entertainment_detail",
            name: "entertainment_detail",
            component: () =>
              import("../views/work_bench/entertainment/detail.vue"),
            meta: { code: 200, title: "超标申请详情" },
          },
        ],
      },
      {
        path: "email",
        name: "email",
        component: () =>
          import(
            /* webpackChunkName: "visit_detail" */ "../views/email/index.vue"
          ),
        meta: { code: 999, title: "邮箱" },
        children: [
          {
            path: "email_detail/:msg_id/:folder",
            name: "email_detail",
            component: () =>
              import(
                /* webpackChunkName: "email_detail" */ "../views/email/email_detail.vue"
              ),
            meta: { code: 999, title: "邮箱" },
          },
          {
            path: "email_write",
            name: "email_write",
            component: () =>
              import(
                /* webpackChunkName: "email_write" */ "../views/email/email_write.vue"
              ),
            meta: { code: 999, title: "邮箱" },
          },
        ],
      },
      {
        path: "query/:key_word?",
        name: "query",
        component: () =>
          import(/* webpackChunkName: "query" */ "../views/query.vue"),
        meta: { title: "库存查询" },
      },
      {
        path: "collection",
        name: "collection",
        component: () =>
          import(
            /* webpackChunkName: "collection" */ "../views/collect_list.vue"
          ),
        meta: { title: "收藏列表" },
      },
      {
        path: "product_display",
        name: "product_display",
        component: () =>
          import(
            /* webpackChunkName: "product_display" */ "../views/product/product_display.vue"
          ),
        meta: { code: 300, title: "产品展示" },
        children: [
          {
            path: "product_detail",
            name: "product_detail",
            component: () =>
              import(
                /* webpackChunkName: "product_detail" */ "../views/product/product_detail.vue"
              ),
            meta: { title: "产品展示" },
          },
        ],
      },
      {
        path: "news",
        name: "news",
        component: () =>
          import(/* webpackChunkName: "news" */ "../views/news.vue"),
        meta: { code: 20, title: "资讯" },
      },
      {
        path: "notify",
        name: "notify",
        component: () =>
          import(/* webpackChunkName: "news" */ "@/views/notify_detail.vue"),
        meta: { code: 2200, title: "消息" },
      },
      {
        path: "instant_messages/:type?",
        name: "instant_messages",
        component: () => import("@/views/instant_messages/index.vue"),
        meta: { code: "2200", title: "消息" },
      },
      {
        path: "/purchase_flow",
        // component: () => import(/* webpackChunkName: "purchase_flow" */ '../views/purchase_flow/index.vue'),
        meta: { code: 9000 },
        children: [
          {
            path: "",
            name: "purchase_flow",
            component: () =>
              import(
                /* webpackChunkName: "purchase_flow" */ "../views/purchase_flow/index.vue"
              ),
            meta: { title: "采购列表" },
          },
          {
            path: "edit",
            name: "purchase_flow_edit",
            component: () => import("../views/purchase_flow/edit.vue"),
            meta: { title: "采购" },
          },
          {
            path: "detail",
            name: "purchase_flow_detail",
            component: () => import("../views/purchase_flow/detail.vue"),
            meta: { title: "采购详情" },
          },
        ],
      },
      {
        path: "/order",
        meta: { code: 9900 },
        children: [
          {
            path: "",
            name: "order_list",
            component: () =>
              import(
                /* webpackChunkName: "purchase_flow" */ "../views/order/index.vue"
              ),
            meta: { title: "订单列表" },
          },
          {
            path: "edit",
            name: "order_edit",
            component: () => import("../views/order/edit.vue"),
            meta: { title: "订单申请" },
          },
          {
            path: "detail",
            name: "order_detail",
            component: () => import("../views/order/detail.vue"),
            meta: { title: "订单详情" },
          },
        ],
      },
      {
        path: "quality_assurance",
        name: "quality_assurance",
        // component: () => import(/* webpackChunkName: "news" */ '@/views/quality_assurance/index.vue'),
        redirect: "quality_assurance",
        meta: { code: 8000 },
        children: [
          {
            path: "complaint/index",
            name: "complaint_index",
            component: () =>
              import("@/views/quality_assurance/complaint/index.vue"),
            meta: { title: "客诉列表" },
          },
          {
            path: "complaint/edit",
            name: "complaint_edit",
            component: () =>
              import("@/views/quality_assurance/complaint/edit.vue"),
            meta: { title: "客诉申请" },
          },
          {
            path: "complaint/detail",
            name: "complaint_detail",
            component: () =>
              import("@/views/quality_assurance/complaint/detail.vue"),
            meta: { title: "客诉详情" },
          },
          {
            path: "change/index",
            name: "change_index",
            component: () =>
              import("@/views/quality_assurance/change/index.vue"),
            meta: { title: "" },
          },
        ],
      },
      {
        path: "system",
        name: "system",
        // component: () => import(/* webpackChunkName: "news" */ '@/views/quality_assurance/index.vue'),
        redirect: "system",
        meta: { code: 888, title: "" },
        children: [
          {
            path: "flow/index",
            name: "flow_index",
            meta: { code: 888, title: "审批流列表" },
            component: () => import("@/views/system/flow/index.vue"),
          },
          {
            path: "flow/workFlowBuilder",
            name: "flow/workFlowBuilder",
            meta: { code: 888, title: "审批流-编辑" },
            component: () => import("@/views/system/flow/WorkflowBuilder.vue"),
          },
        ],
      },
      {
        path: "/pms",
        name: "pms",
        // component: () => import(/* webpackChunkName: "news" */ '@/views/quality_assurance/index.vue'),
        meta: { code: 555 },
        children: [
          {
            path: "project-approval/index",
            name: "project-approval",
            component: () => import("@/views/pms/project-approval/index.vue"),
            meta: { title: "立项申请列表" },
          },
          {
            path: 'project-approval-detail/index',
            name: 'approval',
            component: () => import('@/views/pms/project-approval-detail/index.vue'),
            meta: { title:'立项详情' }
          }, {
            path: 'project-approval-edit/index',
            name: 'project-approval-edit',
            component: () => import('@/views/pms/project-approval-edit/index.vue'),
            meta: { title:'立项申请' }
          }, 
          {
            path: 'project-approval-dialog',
            name: 'project-approval-dialog',
            component: () => import('@/views/pms/project-approval/dialog.vue'),
          },{
            path: 'project-list/index',
            name: 'project-list',
            component: () => import('@/views/pms/project-list/index.vue'),
            meta: { title:'项目管理列表' }
          },{
            path: 'customized-project',
            name: 'customized-project',
            component: () => import('@/views/pms/project-list/customized-project.vue'),
            meta: { title:'定制项目列表' }
          },{
            path: 'research-project',
            name: 'research-project',
            component: () => import('@/views/pms/project-list/research-project.vue'),
            meta: { title:'研发项目列表' }
          },{
            path: 'apply-project',
            name: 'apply-project',
            component: () => import('@/views/pms/project-list/apply-project.vue'),
            meta: { title:'应用项目列表' }
          },{
            path: 'other-project',
            name: 'other-project',
            component: () => import('@/views/pms/project-list/other-project.vue'),
            meta: { title:'信息化管理项目列表' }
          },{
            path: 'noapproval',
            name: 'noapproval',
            component: () => import('@/views/pms/project-list/noapproval.vue'),
            meta: { title:'无审批项目列表' }
          },
          {
            path: "project-approval-edit/index",
            name: "project-approval-edit",
            component: () =>
              import("@/views/pms/project-approval-edit/index.vue"),
            meta: { title: "立项申请" },
          },
          {
            path: "project-list/index",
            name: "project-list",
            component: () => import("@/views/pms/project-list/index.vue"),
            meta: { title: "项目管理列表" },
          },
          {
            path: "project-edit/index",
            name: "project-edit",
            component: () => import("@/views/pms/project-edit/index.vue"),
            meta: { title: "变更申请" },
          },
          {
            path: "project-detail/index",
            name: "project-detail",
            component: () => import("@/views/pms/project-detail/index.vue"),
            meta: { title: "项目详情" },
          },
          {
            path: "project-record/index",
            name: "project-record",
            component: () => import("@/views/pms/project-record/index.vue"),
            meta: { title: "项目变更列表" },
          },
          {
            path: "project-record/detail",
            name: "project-record-detail",
            component: () => import("@/views/pms/project-detail/index.vue"),
            meta: { title: "项目变更详情" },
          },
          {
            path: "task-list/index",
            name: "task-list",
            component: () => import("@/views/pms/task-list/index.vue"),
            meta: { title: "任务列表" },
          },
          {
            path: "task-detail/index",
            name: "task-detail",
            component: () => import("@/views/pms/task-detail/index.vue"),
            meta: { title: "任务详情" },
          },
          {
            path: "task-edit/index",
            name: "task-edit",
            component: () => import("@/views/pms/task-edit/index.vue"),
            meta: { title: "任务" },
          },
          {
            path: "purchase-list/index",
            name: "purchase-list",
            component: () => import("@/views/pms/purchase-list/index.vue"),
            meta: { title: "采购列表" },
          },
          {
            path: "purchasel-detail/index",
            name: "purchasel-detail",
            component: () => import("@/views/pms/purchasel-detail/index.vue"),
            meta: { title: "采购详情" },
          },
          {
            path: "purchasel-edit/index",
            name: "purchasel-edit",
            component: () => import("@/views/pms/purchasel-edit/index.vue"),
            meta: { title: "采购申请" },
          },
          {
            path: "project-cost/index",
            name: "project-cost",
            component: () => import("@/views/pms/project-cost/index.vue"),
            meta: { title: "项目总预算列表" },
          },
          {
            path: "workbenches/index",
            name: "workbenches",
            component: () => import("@/views/pms/workbenches/index.vue"),
            meta: { title: "pms-工作台" },
          },
          {
            path: "role/index",
            name: "role",
            component: () => import("@/views/pms/role-management/index.vue"),
            meta: { title: "角色管理列表" },
          },
          {
            path: "prototype_management",
            name: "prototype_management",
            component: () =>
              import("@/views/pms/prototype_management/index.vue"),
            meta: { title: "样机管理列表" },
          },
          {
            path: "prototype_management_detail",
            name: "prototype_management_detail",
            component: () =>
              import("@/views/pms/prototype_management/detail.vue"),
            meta: { title: "样机管理" },
          },
          {
            path: "/pms/project-management/change-apply/design",
            name: "change-apply",
            meta: { title: "变更申请列表" },
            component: () =>
              import(
                "@/views/pms/project-management/change-apply/design/index.vue"
              ),
          },
          {
            path: "/pms/project-management/change-apply/design/detail/:id?",
            name: "change-apply-detail",
            meta: { title: "变更申请" },
            component: () =>
              import(
                "@/views/pms/project-management/change-apply/design/detail.vue"
              ),
          },
          {
            path: "/pms/project-management/project-problem-management",
            name: "project-problem-management",
            meta: { title: "项目问题管理列表" },
            component: () =>
              import(
                "../views/pms/project-management/project-problem-management/index.vue"
              ),
          },
          {
            path: "/pms/project-management/change-apply/role",
            name: "role",
            meta: { title: "角色管理列表" },
            component: () =>
              import(
                "../views/pms/project-management/change-apply/role/index.vue"
              ),
          },
          {
            path: "/pms/project-management/product/index",
            name: "product-apply",
            meta: { title: "生产变更申请列表" },
            component: () =>
              import("@/views/pms/project-management/product/index.vue"),
          },
          {
            path: "/pms/project-management/product/detail/:id?",
            name: "product-detail",
            meta: { title: "生产变更申请详情" },
            component: () =>
              import("@/views/pms/project-management/product/detail.vue"),
          },
          {
            path: "/pms/role/index",
            name: "role",
            meta: { title: "角色组列表" },
            component: () => import("../views/pms/role/index.vue"),
          },
          {
            path: "workhour",
            name: "workhour",
            component: () => import("../views/pms/workhour/index.vue"),
            meta: { title: "工时管理列表" },
          },
          {
            path: "workhour-declare",
            name: "workhour-declare",
            component: () => import("../views/pms/workhour/declare.vue"),
            meta: { title: "工时申报" },
          },
          {
            path: "project-review",
            name: "project-review",
            component: () => import("../views/pms/project-review/index.vue"),
            meta: { title: "会议纪要列表" },
          },
          {
            path: "project-review-add",
            name: "project-review-add",
            component: () => import("../views/pms/project-review/add.vue"),
            meta: { title: "会议纪要" },
          },
          {
            path: "project-review-detail",
            name: "project-review-detail",
            component: () => import("../views/pms/project-review/detail.vue"),
            meta: { title: "会议纪要详情" },
          },
           {
            path:'documents',
            name:'documents',
            component:()=>import("@/views/pms/documents/index.vue"),
            meta: { title: "项目文件列表" },
          },
          {
            path:'documents/filecd',
            name:'filecd',
            component:()=>import("@/views/pms/documents/filecd.vue"),
             meta: { title: "项目文件" },
          }
        ]
      },
      {
        path: "/sys",
        name: "sys",
        children: [
          {
            name: "sys-org",
            path: "sys-org",
            component: () => import("../views/sys/org/index.vue"),
            meta: { title: "组织管理" },
          },
          {
            name: "sys-dept",
            path: "sys-dept",
            component: () => import("../views/sys/dept/index.vue"),
            meta: { title: "部门管理" },
          },
          {
            name: "sys-user",
            path: "sys-user",
            component: () => import("../views/sys/user/index.vue"),
            meta: { title: "用户管理" },
          },
          {
            name: "sys-duties",
            path: "sys-duties",
            component: () => import("../views/sys/duties/index.vue"),
            meta: { title: "职务管理" },
          },
          {
            path: "sys-adduser",
            name: "sys-adduser",
            component: () => import("../views/sys/components/adduser.vue"),
            meta: { title: "用户管理" },
          },
        ],
      },
      {
        path: "facility",
        name: "facility",
        component: () =>
          import(/* webpackChunkName: "news" */ "@/views/facility/index.vue"),
        meta: { title: "设备管理" },
      },
      {
        path: "tagprint",
        name: "tagprint",
        component: () => import("@/views/work_bench/erp/tagprint.vue"),
        meta: { title: "订单管理列表" },
      },
      {
        path: "printer",
        name: "printer",
        component: () => import("@/views/work_bench/erp/printconfig.vue"),
        meta: { title: "打印配置" },
      },
      {
        path: "productpick",
        name: "productpick",
        component: () => import("@/views/work_bench/erp/productpick.vue"),
        meta: { title: "生产领料单列表" },
      },
      {
        path: "material-purchase",
        name: "material-purchase",
        component: () => import("@/views/work_bench/erp/material-purchase.vue"),
        meta: { title: "物料采购列表" },
      },
      {
        path: "trip",
        name: "trip",
        component: () => import("@/views/trip/index.vue"),
        meta: { title: "出差申请列表" },
      },
      {
        path: "tripadd",
        name: "tripadd",
        component: () => import("@/views/trip/add.vue"),
        meta: { title: "出差申请详情" },
      },
      {
        path: "productorder",
        name: "productorder",
        component: () => import("@/views/work_bench/erp/productorder.vue"),
        meta: { title: "生产订单列表" },
      },
      {
        path: "productsimple",
        name: "productsimple",
        component: () => import("@/views/work_bench/erp/productsimple.vue"),
        meta: { title: "简单生产领料单" },
      },
      {
        path: "budget",
        name: "budget",
        component: () => import("@/views/finance/budget/index.vue"),
        meta: { title: "预算调整列表" },
      },
      {
        path: "budget-add",
        name: "budget-add",
        meta: { title: "预算调整申请" },
        component: () => import("@/views/finance/budget/add.vue"),
      },
      {
        path: "budget-detail",
        name: "budget-detail",
        meta: { title: "预算调整详情" },
        component: () => import("@/views/finance/budget/detail.vue"),
      },
      {
        path: "budget-report",
        name: "budget-report",
        meta: { title: "预算报表列表" },
        component: () => import("@/views/finance/budget-report/index.vue"),
      },
      {
        path: "project-report",
        name: "project-report",
        meta: { title: "项目报表列表" },
        component: () => import("@/views/finance/project-report/index.vue"),
      },
      {
        path: "budget-stand",
        name: "budget-stand",
        meta: { title: "预算设置列表" },
        component: () => import("@/views/finance/budget-stand/index.vue"),
      },
      {
        path: "public-admin-benefit",
        name: "public-admin-benefit",
        meta: { title: "福利费申请列表" },
        component: () => import("@/views/public-admin/benefit/index.vue"),
      },
      {
        path: "public-admin-benefit-add",
        name: "public-admin-benefit-add",
        meta: { title: "福利费申请" },
        component: () => import("@/views/public-admin/benefit/add.vue"),
      },
      {
        path: "public-admin-benefit-detail",
        name: "public-admin-benefit-detail",
        meta: { title: "福利费申请详情" },
        component: () => import("@/views/public-admin/benefit/detail.vue"),
      },
    ],
  },
  {
    path: "/phone",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/phone_show.vue"),
  },
  {
    path: "/lucky",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/lucky"),
  },
  {
    path: "/privacy",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/privacy"),
  },
  {
    path: "/agreement",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "@/views/agreement"),
    meta: { title: "用户协议" },
  },
  {
    path: "/lucky2",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/lucky2"),
  },
  {
    path: "/lucky_draw",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/lucky_draw.vue"),
  },
  {
    path: "/404",
    component: () =>
      import(/* webpackChunkName: "NotFound" */ "../views/NotFound.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login.vue"),
  },
  {
    path: "/login_email",
    name: "login_email",
    component: () =>
      import(/* webpackChunkName: "login_email" */ "../views/login_email.vue"),
    meta: { title: "登录邮箱" },
  },
  {
    path: "/forget_password",
    name: "forget_password",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/forget_password.vue"),
    meta: { title: "忘记密码" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // mode: "hash",
  routes,
});

export default router;
